/**
 * Organism · Footer — keeps the copyright year current.
 *
 * The year ships in the markup so it is right without JavaScript and right for
 * a crawler; this only corrects it once the clock rolls over.
 */
export function initFooterYear(scope: ParentNode = document): void {
  const year = String(new Date().getFullYear());
  scope.querySelectorAll<HTMLElement>('[data-fc-year]').forEach((el) => {
    el.textContent = year;
  });
}
